export default {
    overtimeRequest: 'คำขอ OT',
    searchByEmployeeName: 'ค้นหาจากชื่อ, รหัสพนักงาน',
    search: 'ค้นหา',
    allStatus: 'ทุกสถานะ',
    pending: 'กำลังดำเนินการ',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    no: 'ลำดับ',
    employeeNo: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    requestDate: 'วันที่ขอ',
    group: 'กลุ่ม',
    department: 'แผนก',
    inquiry: 'คำร้องขอ',
    headDepartmentApproval: 'ผลจากหัวหน้า',
    status: 'สถานะ'
}
